import React, { useState, useEffect, useRef } from 'react'
import ListProduct from './ListProduct'
import Clickable from './Clickable'
import { useDispatch, useSelector } from 'react-redux'
import { loadEntityForce } from '../store/slices/entities/crmActions'
import { getAllFilteredProducts, getProductsFilters, productsResetFilters, productsSetFilters } from '../store/slices/entities/products'
import { apiCallBegan } from '../store/api'
import { cartAddItem, cartCleaned, getUser, getUserGeo } from '../store/slices/user'
import { getWorkingOrder, workingOrderReset } from '../store/slices/entities/orders'
import { CLOSE_POPUP, showAlert, SHOW_POPUP } from '../store/slices/ui'
import { FaSortAmountDown } from "@react-icons/all-files/fa/FaSortAmountDown";
import { FaSortNumericDown } from "@react-icons/all-files/fa/FaSortNumericDown";
import { FaLongArrowAltDown } from "@react-icons/all-files/fa/FaLongArrowAltDown";
import { FaLongArrowAltUp } from "@react-icons/all-files/fa/FaLongArrowAltUp";
import { FaDollarSign } from "@react-icons/all-files/fa/FaDollarSign";
import { FiTruck } from '@react-icons/all-files/fi/FiTruck'
import { AiOutlineShoppingCart } from '@react-icons/all-files/ai/AiOutlineShoppingCart'
import { getWorkingPackage } from '../store/slices/entities/packages'
import { helper } from '../utilities/helper'
import { useRouter } from 'next/router'
import { CarouselJsonLd } from 'next-seo';
import AudioAction from './design-system/audio/AudioAction';
import { useOrderFlow } from './unified-order/OrderFlowProvider';
import RentalStartPopup from './design-system/commerce/RentalStartPopup';
import ProductCatalog from './design-system/commerce/ProductCatalog';
import { resolveOrderProduct } from '../utilities/orderProductHydration';
import * as gtag from '../lib/gtag'
import { requiresMiamiFulfillment, resolveShoppingMarket } from '../utilities/fulfillmentMarket'

const LegacyProductList = ({ products, anchor, className, listName, sortBy, filter, preFilter, guide, noTop, carousel, ui }) => {
    let [activeFilter, setActiveFilter] = useState('')
    let { miami } = useSelector(getProductsFilters)
    let dispatch = useDispatch()
    let { cart } = useSelector(getUser)
    let [pages, setPages] = useState()
    let [page, setPage] = useState(0)
    let [pageChange, setPageChange] = useState(false)
    let [sort, setSort] = useState('Relevance')
    let workingPackage = useSelector(getWorkingPackage)
    let order = useSelector(getWorkingOrder)
    let geo = useSelector(getUserGeo)
    let {pathname} = useRouter()
    let _orlando = resolveShoppingMarket({geo, order, pathname}) === 'Orlando'
    //products = products.filter( p => p.name.includes(activeFilter))

    let [pageArr, setPageArr] = useState()
    let ref = useRef()
    useEffect(() => {
        if (page > 0 || pageChange) ref.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
        });
    }, [page])
    useEffect(() => {

        let _p = products.filter(p => p.name.includes(activeFilter))
        setPage(0)
        setPages(Math.ceil(_p.length / 10))
        setPageArr([...new Array(Math.ceil(_p.length / 10))])

    }, [products, activeFilter])

    let _products = useSelector(getAllFilteredProducts)
    let filters = useSelector(getProductsFilters)
    let { launchIntent, unifiedEnabled } = useOrderFlow()
    let unifiedEligible = unifiedEnabled && !workingPackage && !order?._id && !cart.items?.length

    let sortFunc = (a, b) => {
        let quality = ['Standard', 'Premium', 'Top Quality']
        let dj_level = ['Intermediate', 'Professional']


        if (sort === 'Relevance' && !_orlando) return ((b.marketing_priority || 1) - (a.marketing_priority ||1))
        if (sort === 'price-hl') return b.price?.rental - a.price?.rental
        if (sort === 'price-lh') return a.price?.rental - b.price?.rental
        if (sort === 'Wattage') return b.snippets?.find(s => s.includes('Wattage'))?.split('//')?.[1]?.split('W')?.[0] - a.snippets?.find(s => s.includes('Wattage'))?.split('//')?.[1]?.split('W')?.[0]
        if (sort === 'Resolution') return b.snippets?.find(s => s.includes('Resolution'))?.split('//')?.[1]?.split('x')?.[0] - a.snippets?.find(s => s.includes('Resolution'))?.split('//')?.[1]?.split('x')?.[0]
        if (sort === 'Throw Distance') return b.snippets?.find(s => s.includes('Throw Distance'))?.split('//')?.[1]?.split('\'')?.[0] - a.snippets?.find(s => s.includes('Throw Distance'))?.split('//')?.[1]?.split('\'')?.[0]
        if (sort === 'Screen Size') return b.snippets?.find(s => s.includes('Screen Size'))?.split('//')?.[1]?.split('\"')?.[0] - a.snippets?.find(s => s.includes('Screen Size'))?.split('//')?.[1]?.split('\"')?.[0]
        if (sort === 'Release Year') return b.snippets?.find(s => s.includes('Release Year'))?.split('//')?.[1] - a.snippets?.find(s => s.includes('Release Year'))?.split('//')?.[1]
        if (sort === 'Lumens') return b.snippets?.find(s => s.includes('Lumens'))?.split('//')?.[1] - a.snippets?.find(s => s.includes('Lumens'))?.split('//')?.[1]
        if (sort === 'Event Size') return b.snippets?.find(s => s.includes('Event Size'))?.split('//')?.[1]?.split(' People')?.[0] - a.snippets?.find(s => s.includes('Event Size'))?.split('//')?.[1]?.split(' People')?.[0]
        if (sort === 'Capacity') return b.snippets?.find(s => s.includes('Capacity'))?.split('//')?.[1]?.split(' People')?.[0] - a.snippets?.find(s => s.includes('Capacity'))?.split('//')?.[1]?.split(' People')?.[0]
        if (sort === 'Area') return b.snippets?.find(s => s.includes('Area'))?.split('//')?.[1]?.split(' sqft')?.[0] - a.snippets?.find(s => s.includes('Area'))?.split('//')?.[1]?.split(' sqft')?.[0]
        if (sort === 'Pitch') return a.snippets?.find(s => s.includes('Pitch'))?.split('//')?.[1]?.split('mm')?.[0] - b.snippets?.find(s => s.includes('Pitch'))?.split('//')?.[1]?.split('mm')?.[0]
        if (sort === 'Screen Area') return b.snippets?.find(s => s.includes('Screen Area'))?.split('//')?.[1]?.split(' sqft')?.[0] - a.snippets?.find(s => s.includes('Screen Area'))?.split('//')?.[1]?.split(' sqft')?.[0]
        if (sort === 'Height') return b.snippets?.find(s => s.includes('Height'))?.split('//')?.[1]?.split('"')?.[0] - a.snippets?.find(s => s.includes('Height'))?.split('//')?.[1]?.split('"')?.[0]
        if (sort === 'Length') return b.snippets?.find(s => s.includes('Length'))?.split('//')?.[1]?.split('"')?.[0] - a.snippets?.find(s => s.includes('Length'))?.split('//')?.[1]?.split("'")?.[0]
        if (sort === 'Sound Quality') return quality.indexOf(b.snippets?.find(s => s.includes('Sound Quality'))?.split('//')?.[1]) - quality.indexOf(a.snippets?.find(s => s.includes('Sound Quality'))?.split('//')?.[1])
        if (sort === 'DJ Level') return dj_level.indexOf(b.snippets?.find(s => s.includes('DJ Level'))?.split('//')?.[1]) - dj_level.indexOf(a.snippets?.find(s => s.includes('DJ Level'))?.split('//')?.[1])
        if (sort === 'Mic Type') return b.snippets?.find(s => s.includes('Mic Type'))?.split('//')?.[1]?.length - a.snippets?.find(s => s.includes('Mic Type'))?.split('//')?.[1]?.length
        if (sort === 'Screen Type') return b.snippets?.find(s => s.includes('Screen Type'))?.split('//')?.[1]?.length - a.snippets?.find(s => s.includes('Screen Type'))?.split('//')?.[1]?.length
        if (_orlando) return b.orlando - a.orlando
        if (sort === 'Relevance') return ((b.marketing_priority || 1) - (a.marketing_priority ||1))
        else return b.snippets?.find(s => s.includes(sort))?.split('//')?.[1] - a.snippets?.find(s => s.includes(sort))?.split('//')?.[1]
    }

    let loadOrderProduct = async (requestedProduct, showSpinner = true) => {
        let loadedProducts
        if (filters.static) {
            loadedProducts = await dispatch(loadEntityForce('products', null, null, showSpinner))
            dispatch(productsResetFilters())
        }
        let orderProducts = Array.isArray(loadedProducts) ? loadedProducts : _products
        let currentProduct = resolveOrderProduct({
            requestedProduct,
            loadedProducts,
            cachedProducts: _products
        })

        return { currentProduct, orderProducts }
    }

    let addToCartItems = async (p, delivery) => {
        let units = 1

        if (unifiedEligible && !p.only_purchase && !p.price?.map) {
            return launchIntent({
                kind: 'product',
                entityId: p._id,
                entityName: p.name,
                sourceSurface: `product_list:${listName || pathname}`,
                fulfillment: delivery ? 'delivery_setup' : 'pickup'
            })
        }

        if(order?.request_type === 'purchase' && !p.price.map) {
            if(!window.confirm(`This product is only available for rent, do you want to create a new rental order?`)) return
            else return   await dispatch(apiCallBegan({ url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type, onSuccessFunc: () => cartCleaned() }))
        }
        let { currentProduct: _pr, orderProducts } = await loadOrderProduct(p)

        if (!_pr) return dispatch(showAlert({ type: 'error', alert: `${p.name} could not be loaded. Please refresh and try again.` }))

        if (delivery) {
            if (_orlando && requiresMiamiFulfillment(_pr, units)) {


                if (!window.confirm(`${_pr?.name} is available from Miami, not Orlando, for these dates. Continuing will create or convert the order to Miami fulfillment and may add a travel fee. Continue?`)) return
            }

            if (!cart.production && order._id) await dispatch(apiCallBegan({ url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type, showSpinner: true }))
            return dispatch(cartAddItem({ product: _pr, units, category: p.categories[0].split('/')[1], delivery: true }))

        } else {
            if (order?._id && units > 0 && (_pr.available - units < 0 || (_pr.bundle && _pr.included?.some(ip => orderProducts.find(produ => String(produ._id) == String(ip.product._id))?.available - (units * ip.units) < 0)))) return dispatch(showAlert({ type: 'error', alert: `${p.name} has no more units available for the selected date` }))
            if (!cart.production && (p.requires_tech || !p.allow_pickup)) {
                if (!window.confirm(`${p.name} requires installation by a Miami Sound Rental technician, adding it to your order will convert it to a production. Do you wish to continue?`)) return
                else if (order._id) {

                    await dispatch(apiCallBegan({ url: `/order/${order._id}`, method: 'DELETE', onSuccess: workingOrderReset.type }))
                }
            }


            await dispatch(cartAddItem({ product: _pr, units, category: p.categories[0].split('/')[1] }))
        }


    }
    let openRentalStart = product => {
        gtag.event({ action: 'rent_online_cta_click', label: 'sales', value: 5, category: 'orders' })
        dispatch(SHOW_POPUP({
            key: `rentalStart-${product._id}`,
            size: 'xl',
            className: 'rentalStartShell',
            trapFocus: true,
            ariaLabelledBy: 'rental-start-title',
            body: <RentalStartPopup
                product={product}
                orlando={_orlando}
                selectionOnly={unifiedEligible}
                resolveProduct={unifiedEligible ? undefined : async () => {
                    let { currentProduct } = await loadOrderProduct(product, false)
                    if (!currentProduct) {
                        dispatch(showAlert({ type: 'error', alert: `${product.name} could not be loaded. Please refresh and try again.` }))
                        return null
                    }
                    gtag.event({
                        action: 'add_to_cart',
                        label: 'sales',
                        value: currentProduct.price?.rental,
                        category: 'orders',
                        currency: 'USD',
                        items: [{
                            item_id: currentProduct._id,
                            item_name: currentProduct.name,
                            index: 0,
                            item_category: currentProduct.categories?.[0]?.split('/')?.[0],
                            item_category2: currentProduct.categories?.[0]?.split('/')?.[1],
                            price: currentProduct.price?.rental,
                            quantity: 1
                        }]
                    })
                    return currentProduct
                }}
                onSelect={async (delivery, selectedProduct) => {
                    gtag.event({
                        action: delivery ? 'rent_online_delivery_selected' : 'rent_online_pickup_selected',
                        label: 'sales',
                        value: 5,
                        category: 'orders'
                    })
                    if (unifiedEligible) {
                        dispatch(CLOSE_POPUP({ all: true }))
                        await addToCartItems(selectedProduct, delivery)
                        return false
                    }
                    if (delivery && _orlando && requiresMiamiFulfillment(selectedProduct)) {
                        if (!window.confirm(`${selectedProduct.name} is available from Miami, not Orlando. Continuing will create a Miami-fulfilled order and may add a travel fee. Continue?`)) return false
                    }
                    return true
                }}
            />
        }))
    }
    let products_sorted  = products?.sort(sortFunc).filter(p => (p.name.includes(activeFilter) || p.tags.some(t => t === activeFilter)) && (_orlando || !p.only_orlando))
    return <div className={`productList ${className}`} id={anchor ? 'productsAnchor' : ''}>
        <div ref={ref} id={'catalog'} className={`listHead ${listName ? 'nameHead' : ''}`}>
            {listName && < >
                <h3 className='upperBold' >{listName}</h3>
                <div className="sortFilter">
                    {(filter || _orlando) && <div className='filterBy' >
                        {ui === 'v2' ? <AudioAction mode='filter' className={`filterOption ${!activeFilter && miami ? 'sel' : ''}`} ariaPressed={!activeFilter && miami} onClick={() => {
                            dispatch(productsSetFilters({ miami: true }))
                            setActiveFilter('')
                        }} >View All</AudioAction> : <Clickable className={`filterOption  ${!activeFilter && miami ? 'sel' : ''}`} onClick={() => {
                            dispatch(productsSetFilters({ miami: true }))
                            setActiveFilter('')
                        }} >View All</Clickable>}
                        {_orlando && (ui === 'v2'
                          ? <AudioAction mode='filter' className={`filterOption ${!miami ? 'sel' : ''}`} ariaPressed={!miami} onClick={() => dispatch(productsSetFilters({ miami: false }))}>Available in My Store</AudioAction>
                          : <Clickable className={`filterOption  ${!miami ? 'sel' : ''}`} onClick={() => dispatch(productsSetFilters({ miami: false }))} >Available in My Store</Clickable>)}
                        {filter?.map((f) => ui === 'v2'
                          ? <AudioAction mode='filter' key={f[0]} className={`filterOption ${activeFilter === f[1] ? 'sel' : ''}`} ariaPressed={activeFilter === f[1]} onClick={() => setActiveFilter(f[1])}>{f[0]}</AudioAction>
                          : <Clickable key={f[0]} className={`filterOption  ${activeFilter === f[1] ? 'sel' : ''}`} onClick={() => setActiveFilter(f[1])} >{f[0]}</Clickable>)}
                    </div>}

                    <div className='sortBy'>
                        <div className='thick'>Sort By:</div>
                        <div className={`inputIcon`}>
                            <label htmlFor='sort' > {sortBy?.[sort] ? sortBy[sort][1] : sort === 'Relevance' ? <FaSortAmountDown /> : sort.includes('price') ? <FaDollarSign /> : null}{sort.includes('hl') ? <FaLongArrowAltDown className='sortArrow' /> : sort.includes('lh') ? <FaLongArrowAltUp className='sortArrow' /> : null}</label>
                            <select id='sort' aria-label='sort' value={sort} onChange={(e) => setSort(e.target.value)} >
                                <option value="Relevance">Relevance</option>
                                <option value="price-hl">Price High to Low</option>
                                <option value="price-lh">Price Low to High</option>
                                {sortBy && Object.keys(sortBy)?.map((s, i) => <option key={i} value={s}>{s}</option>)}

                            </select>
                        </div>
                    </div>
                </div>

            </>}
        </div>
      {!noTop &&  <div className='rentGuide' >

            {products?.some(p => p.allow_pickup) && !workingPackage && <>
                <div className="guideBlock">
                    <p>Select the rental button, then choose <strong>warehouse pickup</strong> or <strong>delivery &amp; setup</strong>. We ask for the dates and location first so we can show real availability from the correct warehouse.</p>
                    <div className="example">
                        <AiOutlineShoppingCart /> Choose Dates &amp; Rent Online
                    </div>
                </div>

            </>}
            <div className={`longDiscount ${products?.some(p => p.allow_pickup) && !workingPackage ? 'topBorder' : ''}`}>
                <div className="highlight">
                    <strong className="bold ">15%-30%</strong>
                </div>
                <strong className='mleft mright'> Discount</strong> at checkout when renting for more than <strong className='mleft'>24 hours</strong>.
            </div>
        </div>}

        {products_sorted.slice(page * 10, (page * 10) + 10).map((p, i) => <ListProduct addToCartItems={addToCartItems} openRentalStart={openRentalStart} unifiedEligible={unifiedEligible} key={p._id} index={i} p={p} ui={ui} />)}
        {pages > 1 && <div className='pagesComp'>
            <div data-msr-surface='dark' className='pagesRow'>
                {pageArr?.map((p, i) => ui === 'v2' ? <AudioAction mode='pagination' ariaCurrent={page === i ? 'page' : undefined} className={page === i ? 'sel' : ''} key={i} onClick={() => {
                    setPageChange(true)
                    setPage(i)
                }} >{i + 1}</AudioAction> : <Clickable className={page === i ? 'sel' : ''} key={i} onClick={() => {
                    setPageChange(true)
                    setPage(i)
                }} >{i + 1}</Clickable>)}
            </div>
        </div>}
        {carousel &&     <CarouselJsonLd
      ofType="default"
      url={carousel.url}
      name={carousel.name}
      description={carousel.description}
      data={products_sorted.map((p, i) => ({
    position: i + 1,
    type: "Product",
    name: p.name,         // "8'x12' Stage, 16\" height"
    url: `https://miamisoundrental.com/products/${helper.makeUrl(p.name)}`,
    image:helper.findImage( p.picture),       // main image URL
    offers: {             // keep minimal on listing pages
      price:p.only_purchase ?p.price.map : p.price.rental,
      priceCurrency: "USD",

    },
  }))}
    />}
    </div>
}

const ProductList = ({ legacy = false, ...props }) => {
    if (legacy) return <LegacyProductList {...props} />

    return <ProductCatalog
        products={props.products || []}
        listName={props.listName}
        description={props.description}
        eyebrow={props.eyebrow}
        filters={props.filter || []}
        sortOptions={props.sortBy ? Object.keys(props.sortBy) : []}
        showAssurances={props.showAssurances ?? !props.noTop}
        showProductDirectory={props.showProductDirectory}
        pageSize={props.pageSize}
        carousel={props.carousel}
        anchorId={props.anchor ? 'productsAnchor' : props.anchorId}
        className={props.className}
        actionMode={props.actionMode}
        priceSummaryMode={props.priceSummaryMode}
        inventoryMarket={props.inventoryMarket}
        relevanceOrder={props.relevanceOrder}
        impressionMode={props.impressionMode}
        headerDensity={props.headerDensity}
        emptyState={props.emptyState}
    />
}

export default ProductList
